var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1603px",
    height: "1068px",
    viewBox: "0 0 1603 1068",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 1603,
    height: 1068
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WWW-V4_Desktop+Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop_Convert1",
    transform: "translate(-158.000000, -40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "waves",
    transform: "translate(158.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-3",
    strokeOpacity: 0.5,
    stroke: "#DAB971",
    strokeWidth: 2,
    fillOpacity: 0.1,
    fill: "#D92C67",
    fillRule: "nonzero",
    opacity: 0.049999997,
    mask: "url(#mask-2)",
    cx: 801.52,
    cy: 265.09,
    rx: 801.52,
    ry: 801.09
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    strokeOpacity: 0.5,
    stroke: "#DAB971",
    strokeWidth: 2,
    fillOpacity: 0.1,
    fill: "#D92C67",
    fillRule: "nonzero",
    opacity: 0.100000001,
    mask: "url(#mask-2)",
    cx: 801.95,
    cy: 265.09,
    r: 682.41
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    strokeOpacity: 0.5,
    stroke: "#DAB971",
    strokeWidth: 2,
    fillOpacity: 0.1,
    fill: "#D92C67",
    fillRule: "nonzero",
    opacity: 0.200000003,
    mask: "url(#mask-2)",
    cx: 801.52,
    cy: 265.52,
    r: 566.74
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeOpacity: 0.5,
    stroke: "#DAB971",
    strokeWidth: 2,
    fillOpacity: 0.1,
    fill: "#D92C67",
    fillRule: "nonzero",
    opacity: 0.400000006,
    mask: "url(#mask-2)",
    cx: 801.95,
    cy: 265.09,
    r: 448.49
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    strokeOpacity: 0.233528191,
    stroke: "#DAB971",
    strokeWidth: 2,
    fillOpacity: 0.1,
    fill: "#D92C67",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    cx: 801.52,
    cy: 265.52,
    r: 333.68
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    fillOpacity: 0.1,
    fill: "#D92C67",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    cx: 801.3,
    cy: 265.3,
    r: 219.3
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles);
export default __webpack_public_path__ + "static/media/circles.d34fc267.svg";
export { ForwardRef as ReactComponent };